export const LESSON_TYPES = Object.freeze({
  ON_DEMAND: 1,
  LIVE: 2,
  HOMEWORK: 3,
  PRIVATE_REPLAY: 4,
  AUDIO: 5,
  RICH_MEDIA: 6,
})

export const UNKNOWN_LESSON_TYPE_CONFIG = Object.freeze({
  type: 0,
  label: '课时',
  listLabel: '暂不支持',
  tagClass: 'tag-unknown',
  tagType: 'info',
  playbackKind: 'unsupported',
  isKnown: false,
  canTrial: false,
})

export const LESSON_TYPE_CONFIG = Object.freeze({
  [LESSON_TYPES.ON_DEMAND]: Object.freeze({
    type: LESSON_TYPES.ON_DEMAND,
    label: '点播',
    listLabel: '视频',
    tagClass: 'tag-video',
    tagType: '',
    playbackKind: 'video',
    isKnown: true,
    canTrial: true,
  }),
  [LESSON_TYPES.LIVE]: Object.freeze({
    type: LESSON_TYPES.LIVE,
    label: '直播',
    listLabel: '直播',
    tagClass: 'tag-live',
    tagType: 'success',
    playbackKind: 'live',
    isKnown: true,
    canTrial: true,
  }),
  [LESSON_TYPES.HOMEWORK]: Object.freeze({
    type: LESSON_TYPES.HOMEWORK,
    label: '作业',
    listLabel: '作业',
    tagClass: 'tag-homework',
    tagType: 'warning',
    playbackKind: 'homework',
    isKnown: true,
    canTrial: false,
  }),
  [LESSON_TYPES.PRIVATE_REPLAY]: Object.freeze({
    type: LESSON_TYPES.PRIVATE_REPLAY,
    label: '私教课',
    listLabel: '直播',
    tagClass: 'tag-live',
    tagType: '',
    playbackKind: 'liveReplay',
    isKnown: true,
    canTrial: false,
  }),
  [LESSON_TYPES.AUDIO]: Object.freeze({
    type: LESSON_TYPES.AUDIO,
    label: '音频',
    listLabel: '音频',
    tagClass: 'tag-audio',
    tagType: '',
    playbackKind: 'audio',
    isKnown: true,
    canTrial: true,
  }),
  [LESSON_TYPES.RICH_MEDIA]: Object.freeze({
    type: LESSON_TYPES.RICH_MEDIA,
    label: '图文课',
    listLabel: '图文',
    tagClass: 'tag-rich-media',
    tagType: 'info',
    // 不是视频播放：由 rich-media-lesson 阅读器渲染，不挂载播放器、不发心跳
    playbackKind: 'rich_media',
    isKnown: true,
    // 试听与直播一样只有「无 / 完整课时」（trial_duration = -1），没有分钟制（2026-09-13 拍板）
    canTrial: true,
  }),
})

export function normalizeLessonType(type) {
  const normalizedType = Number(type)
  return Number.isFinite(normalizedType) ? normalizedType : 0
}

export function getLessonTypeConfig(type) {
  const normalizedType = normalizeLessonType(type)
  return (
    LESSON_TYPE_CONFIG[normalizedType] || {
      ...UNKNOWN_LESSON_TYPE_CONFIG,
      type: normalizedType,
    }
  )
}

export function getLessonTypeLabel(type) {
  return getLessonTypeConfig(type).label
}

export function isKnownLessonType(type) {
  return getLessonTypeConfig(type).isKnown
}

export function isAudioLessonType(type) {
  return normalizeLessonType(type) === LESSON_TYPES.AUDIO
}

export function isOnDemandLessonType(type) {
  return normalizeLessonType(type) === LESSON_TYPES.ON_DEMAND
}

export function isRichMediaLessonType(type) {
  return normalizeLessonType(type) === LESSON_TYPES.RICH_MEDIA
}

// 点播/音频/图文课共享"按发布时间可见、报名后可读"的规则；不含播放器语义。
export function isReadableOnDemandLessonType(type) {
  return isOnDemandLikeLessonType(type) || isRichMediaLessonType(type)
}

export function isOnDemandLikeLessonType(type) {
  return [LESSON_TYPES.ON_DEMAND, LESSON_TYPES.AUDIO].includes(
    normalizeLessonType(type)
  )
}

export function isLiveLikeLessonType(type) {
  return [LESSON_TYPES.LIVE, LESSON_TYPES.PRIVATE_REPLAY].includes(
    normalizeLessonType(type)
  )
}
